import { render } from "./InformationSlide.vue?vue&type=template&id=77f87c10&scoped=true"
import script from "./InformationSlide.vue?vue&type=script&lang=js"
export * from "./InformationSlide.vue?vue&type=script&lang=js"

import "./InformationSlide.vue?vue&type=style&index=0&id=77f87c10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f87c10"]])

export default __exports__